module.exports = __webpack_public_path__ + "static/media/male.59e8dc68.svg";